import auth from '@app/Middlewares/Auth';
import guest from '@app/Middlewares/Guest';

export default [
  {
    url: '/register',
    page: 'auth/Register',
    name: 'register',
    meta: {
      middleware: [guest],
    },
  },
  {
    url: '/design',
    page: 'Design',
    name: 'design',
    meta: {
      layout: 'Dashboard',
    },
  },
  {
    url: '/dashboard',
    page: 'MainDashboard',
    name: 'dashboard',
    meta: {
      label: 'Dashboard',
      layout: 'Dashboard',
      middleware: [auth],
    },
    group: [
      {
        url: '/payments',
        page: 'payments/Index',
        name: 'payments',
      },
    ],
  },
];
